import {
  attachPerformanceToExercise,
  mapPerformanceSetsFromApi,
  createDefaultPerformanceSets,
  isTimeBasedExercise,
  isHeightBasedExercise,
} from './sessionExercisePerformance';

export function mapDbTrainingExerciseToSessionState(row) {
  const typeName =
    row.catalog_exercise_type_name || row.exercise_type || 'Exercise';
  const typeId =
    row.catalog_exercise_type_id != null
      ? row.catalog_exercise_type_id
      : `loaded-${typeName}`;
  const rowId =
    row.id != null
      ? `tse-${row.id}`
      : `legacy-${row.training_session_id || 'session'}-${typeName}`;
  const base = {
    id: rowId,
    training_session_exercise_id: row.id ?? null,
    exercise_id: row.exercise_id,
    exercise_name: row.exercise_name,
    exercise_type: typeName,
    exercise_type_id: typeId,
    sets: row.sets ?? 1,
    reps: row.reps ?? 1,
    weight_kg: row.weight_kg ?? null,
    height: row.height ?? null,
    tempo: row.tempo ?? null,
    is_time_based_exercise: row.is_time_based_exercise,
    is_height_based: row.is_height_based,
    is_weight_based: row.is_weight_based,
    time: row.time ?? null,
    display_url: row.display_url ?? null,
    display_images: row.display_images ?? null,
    description: row.description ?? null,
    performance_sets:
      mapPerformanceSetsFromApi(row.performance_sets, row) ||
      createDefaultPerformanceSets(row.sets ?? 1, row.reps ?? 1, row),
  };
  return attachPerformanceToExercise(base);
}

function rowSortId(row) {
  const id = row?.id;
  if (id == null) return 0;
  if (typeof id === 'number' && !Number.isNaN(id)) return id;
  const parsed = parseInt(String(id), 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function buildSessionExerciseTypesFromRows(rows) {
  const sorted = [...rows].sort((a, b) => {
    const oa = a.exercise_order ?? 0;
    const ob = b.exercise_order ?? 0;
    if (oa !== ob) return oa - ob;
    return rowSortId(a) - rowSortId(b);
  });
  const byType = new Map();
  sorted.forEach((row) => {
    const mapped = mapDbTrainingExerciseToSessionState(row);
    const key = String(mapped.exercise_type_id);
    if (!byType.has(key)) {
      byType.set(key, {
        id: `type-loaded-${key}`,
        exercise_type_id: mapped.exercise_type_id,
        exercise_type_name: mapped.exercise_type,
        exercises: [],
      });
    }
    byType.get(key).exercises.push(mapped);
  });
  return Array.from(byType.values());
}

export { isTimeBasedExercise, isHeightBasedExercise };
